import React from 'react'
import { useTranslation } from 'react-i18next'
import { KibModal } from '@chewy/kib-overlays-react'

import '@chewy/kib-overlays-styles/dist/styles/kib-modal.css'

export interface MicrophonePermissionModalProps {
  onClose?: () => void
  open: boolean
}

const MicrophonePermissionModal = ({
  open,
  onClose,
}: MicrophonePermissionModalProps) => {
  const { t } = useTranslation('Dialogs')

  return (
    <KibModal
      open={open}
      title={t('AUDIO_RECORDER.MICROPHONE_PERMISSION_MODAL.TITLE')}
      onClose={onClose}
    >
      <p>{t('AUDIO_RECORDER.MICROPHONE_PERMISSION_MODAL.MESSAGE')}</p>
      <p>{t('AUDIO_RECORDER.MICROPHONE_PERMISSION_MODAL.INSTRUCTIONS')}</p>
    </KibModal>
  )
}

export default MicrophonePermissionModal
